import React, { memo } from 'react'

import { Button, classnames, Close, Icon } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool } from 'prop-types'

import { iconSizeMedium } from 'Pods/ThreeDStudio/constants'
import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'
import EditCanvas from 'Pods/ThreeDStudio/Shared/ImageEditor/EditCanvas'
import { useThreeDStudioStore } from 'Pods/ThreeDStudio/Store'
import {
  closeRenderPreview,
  getRenderPreviewSessionId,
  setRenderPreviewSessionId,
} from 'Pods/ThreeDStudio/Store/actions/ui'

const closeIcon = <Icon svgComponent={Close} size={iconSizeMedium} notSpaced />

// isPanelOpen: whether the enhance panel is slid out beside the rail. The preview docks
// against the panel when it is, and against the rail alone when it is not (a render opened
// from the detached History window while the panel is closed).
function RenderPreview({ isPanelOpen = true }) {
  const t = useTranslation()
  const renderPreview = useThreeDStudioStore(state => state.ui.renderPreview)

  if (!renderPreview) {
    return null
  }

  const { image, sessionId } = renderPreview
  const title = t('viewerSidebar.enhance.render.previewTitle')

  return (
    <section
      className={classnames('render-preview', !isPanelOpen && 'render-preview--panel-closed')}
      aria-label={title}
    >
      <div className="render-preview__header">
        <span className="render-preview__title cgt-heading-50">{title}</span>
        <Button
          type="ghost"
          variant="only-icon"
          size="small"
          actionType="button"
          icon={closeIcon}
          aria-label={t('viewerSidebar.enhance.render.previewClose')}
          onClick={closeRenderPreview}
        />
      </div>
      <div className="render-preview__content">
        {/* Keyed on the image so a newer render remounts the editor with a fresh version chain. */}
        <EditCanvas
          key={image.id}
          image={image}
          sessionId={sessionId}
          getSessionId={getRenderPreviewSessionId}
          onSessionCreated={setRenderPreviewSessionId}
          isStartNewHidden
        />
      </div>
    </section>
  )
}

RenderPreview.propTypes = {
  isPanelOpen: bool,
}

export default memo(RenderPreview)
